<template>
  <transition name="slide-fade">
    <div class="dialog-container" v-if="visible">
      <div class="go-back flex-center" @click="handleClick">
        <span class="span-mother">
          <span><i class="el-icon-arrow-left" color="#107782"></i></span>
          <span>返</span>
          <span>回</span>
        </span>
        <span class="span-mother2">
          <span><i class="el-icon-arrow-left" color="#107782"></i></span>
          <span>返</span>
          <span>回</span>
        </span>
      </div>
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'customDialog',
  props: {
    visible: {
      type: Boolean,
    },
  },
  data() {
    return {
      theme: null,
    };
  },
  activated() {
    try {
      if (this.$route.query.id) {
        this.id = this.$route.query.id;
        console.log(this.$route, '路由常熟');
        this.getDelData();
      }
    } catch (error) {
      console.log(error);
    }
  },
  mounted() {
    this.theme = localStorage.getItem('theme');
  },
  methods: {
    handleClick() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
<style lang="less" scoped>
.dialog-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  z-index: 999;
  padding: 10px;
  box-sizing: border-box;
  border-top: 1px solid #bbbbbb;
  // color: #107782;
  .go-back {
    font-weight: bold;
    color: #2d2d30;
    border-radius: 18px;
    cursor: pointer;
    width: 80px;
    height: 35px;
    border: 1px solid #bbbbbb;
    // background-color: #107782;
    .span-mother {
      display: flex;
      overflow: hidden;
    }
    &:hover .span-mother {
      position: absolute;
    }
    &:hover .span-mother span {
      transform: translateY(1.2em);
    }
    & .span-mother span:nth-child(1) {
      transition: 0.2s;
    }
    & .span-mother span:nth-child(2) {
      transition: 0.3s;
    }
    & .span-mother span:nth-child(3) {
      transition: 0.4s;
    }
    .span-mother2 {
      display: flex;
      position: absolute;
      overflow: hidden;
    }
    .span-mother2 span {
      transform: translateY(-1.2em);
    }
    &:hover .span-mother2 span {
      transform: translateY(0);
    }
    & .span-mother2 span {
      transition: 0.2s;
    }
    & .span-mother2 span:nth-child(2) {
      transition: 0.3s;
    }
    & .span-mother2 span:nth-child(3) {
      transition: 0.4s;
    }
  }
  .content {
    width: 100%;
    height: 100%;
    overflow: auto !important;
    margin: 0 auto;
    padding-top: 20px;
    padding-bottom: 100px;
  }
}
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s ease;
}
.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(100%);
}
</style>
